import { Link, type LinkProps } from 'react-router-dom'
import { cn } from '../../../lib/cn'

type Aparencia = 'primario' | 'secundario'

const APARENCIAS: Record<Aparencia, string> = {
  primario: 'bg-niteroi-700 text-white shadow-sm hover:bg-niteroi-800 active:bg-niteroi-900',
  secundario:
    'border border-slate-300 bg-white text-slate-800 shadow-sm hover:border-slate-400 hover:bg-slate-50 ' +
    'active:bg-slate-100',
}

interface Props extends LinkProps {
  aparencia?: Aparencia
}

/**
 * Um endereço com aparência de botão.
 *
 * É `<a>` e não `<button>`, e não é embrulhado num deles: `<a><button></button></a>` é HTML
 * inválido, e o leitor de tela anuncia dois controles onde há um. Sendo link de verdade, o
 * "abrir em nova aba", o "copiar endereço" e o clique do meio continuam funcionando — que é o que
 * se espera de qualquer coisa que leve a outra tela.
 *
 * Mora aqui, e não em `components/`, porque a aparência é a mesma de `Botao` e duplicá-la três
 * vezes no assistente é como os tons de botão do sistema anterior começaram a divergir.
 *
 * @param props destino, aparência e o que mais um `Link` aceita
 * @returns o link estilizado
 */
export function LinkDeAcao({ aparencia = 'secundario', className, ...resto }: Props) {
  return (
    <Link
      className={cn(
        'inline-flex items-center justify-center gap-2 rounded-lg px-3.5 py-2 text-sm font-medium',
        'transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2',
        'focus-visible:outline-niteroi-600',
        APARENCIAS[aparencia],
        className,
      )}
      {...resto}
    />
  )
}
